import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}`
// ;

console.log(API_URL, "API_URL")
  export const adminLogin = async (data) => {
    console.log(data, "data>>>>>>")
    try {
      const response = await axios.post(
        `${API_URL}auth/admin-login`,
          data
      );
      console.log(response.data, "response return ")
      return response;
    } catch (error) {
      console.error('Error fetching tournaments:', error);
      throw error;
    }
  }